import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LoginComponent } from '@auth/pages/login.component';

@Component({
  selector: 'app-unicon-register-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unicon-register-modal.component.html',
  styleUrls: ['./unicon-register-modal.component.scss']
})
export class UniconRegisterModalComponent {
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  private bottomSheet = inject(MatBottomSheet);

  constructor(private router: Router) {}

  closeModal() {
    this.closed.emit();
  }

  goToRegister() {
    this.router.navigate(['/auth/register']);
    this.closeModal();
  }

  goToLogin() {
    this.closeModal();
    this.bottomSheet.open(LoginComponent, {
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'login-bottom-sheet',
    });
  }
}
